export default {
    system: {
        auth: `You must log in`,
        apiError: 'Failed to contact the server! Try again later...'
    },
    game: {
        gameNotFound: `This game not exist`,
        wrongAvatar: `This avatar doesn't exist`,
        favoriteGameNotFound: 'This game not exist'
    },
    user: {
        auth: {
            wrongData: 'Invalid username or password'
        }
    },
    password: {
        wrongOldPassword: 'The old password was entered incorrectly',
        wrongFormat: 'The password must consist of 6 digits',
        notMatch: `The new passwords don't match`,
        success: 'The password has been successfully changed!'
    },
    bonus: {
        wrongType: 'Wrong bonus type! Try again later...',
        wrongBonus: `Wrong bonus! Try again later...`,
        rulesNotMet: `Bonus rules not met`,
        alreadyExist: `You have already claimed this bonus!`,
        cantLoad: 'The bonus could not be credited! Try again later...',
        soon: 'This bonus is currently unavailable',
        daily_no_deposit: 'You must make a $15 deposit to unlock the daily bonuses',
        weekly_no_deposit: 'You must make a $30 deposit to unlock the weekly bonuses',
    }
}